import React, { useEffect, useState } from "react";
import AuthLayout from "../../Components/Layouts/AuthLayout";
import { NavLink, Outlet, useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/store";
import { getJobById } from "../../features/jobSlice";

const ManageJobs = () => {
  // Always call hooks at the top level
  const [loading, setLoading] = useState(false);

  const [executed, setHasExecute] = useState(false);

  // Get state from Redux
  const { singleJob } = useAppSelector((state) => state.job);

  const dispatch = useAppDispatch();

  // Extract jobId from the query string
  const { id } = useParams();

  const validJobId = id ? Number(id) : 0;

  useEffect(() => {
    if (validJobId) {
      setLoading(true); // Start loading
      dispatch(getJobById(validJobId)).finally(() => setLoading(false)); // Stop loading after fetching
    }
  }, [dispatch, validJobId]);

  const navigate = useNavigate();

  return (
    <div>
      <AuthLayout>
        <span
          style={{ cursor: "pointer" }}
          onClick={() => navigate(-1)}
          className="text-decoration-none fw-bold text-primary"
        >
          <i className="bi bi-arrow-left border-primary"></i> Back
        </span>
        <div className="manage-job-container bg-white">
          <div className="d-flex justify-content-between">
            <div>
              <h4 className="general-header">Manage Job</h4>
            </div>
            <div>
              <span>Job Title</span> <br />
              <span className="general-header">{singleJob?.jobTitle}</span>
            </div>
          </div>

          <nav className="tab-nav">
            <NavLink
              to={`details/${validJobId}`}
              className={({ isActive }) => (isActive ? "tab active" : "tab")}
            >
              Job Details
            </NavLink>
            <NavLink
              to={`manage-applicants/${validJobId}`}
              className={({ isActive }) => (isActive ? "tab active" : "tab")}
            >
              Manage Applicants
            </NavLink>
            <NavLink
              to="questions"
              className={({ isActive }) => (isActive ? "tab active" : "tab")}
            >
              Interview Screener Questions
            </NavLink>
            <NavLink
              to="candidate-screener"
              className={({ isActive }) => (isActive ? "tab active" : "tab")}
            >
              Candidate Screener
            </NavLink>
          </nav>
          <div className="tab-content">
            {/* Pass validJobId to all child routes */}
            <Outlet context={validJobId} />
          </div>
        </div>
      </AuthLayout>
    </div>
  );
};

export default ManageJobs;
